import ProvisionLogin from '../../assets/svg/provision-login.svg'
import AssessmentLogin from '../../assets/svg/assessment-login.svg'
import MigrateToAsLogin from '../../assets/svg/migrate-to-as-code-login.svg'
import AccountFactoryLogin from '../../assets/svg/account-factory-login.svg'

export const imageData = [
	{
		image: ProvisionLogin,
		title: "Self-Service Provisioning",
		description: "Accelerates infrastructure deployment across cloud platforms while ensuring security compliance. Simplify workflows and prioritize innovation with seamless infrastructure management"
	},
	{
		image: AssessmentLogin,
		title: "Automation Assessment",
		description: "Evaluates your cloud infrastructure, comparing Terraform-managed to non-managed resources. It provides an automation percentage score and lists resources not yet Terraform-managed, enabling informed optimization"
	},
	{
		image: MigrateToAsLogin,
		title: "Migrate to As Code",
		description: "This feature automates Terraform file generation from existing infrastructure, encompassing all dependencies. Its Import functionality seamlessly integrates current setups into Infrastructure as Code (IaC) management, generating a state file and corresponding code for smooth synchronization with IaC tools"
	},
	{
		image: AccountFactoryLogin,
		title: "Account Factory",
		description: "Automates AWS account creation and customization with a single click. Newly created accounts adhere to security best practices, provide restricted access, and streamline developer setup for prompt infrastructure deployment"
	}
];